import { SVGProps } from "react";

export const SOLIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <circle cx="32" cy="32" r="32" fill="#111111" />
    <path
      d="M18.5 17.5h30.8c.9 0 1.3 1.1.7 1.7l-5.8 5.8c-.4.4-.9.6-1.4.6H12c-.9 0-1.3-1.1-.7-1.7l5.8-5.8c.4-.4.9-.6 1.4-.6z"
      fill="#14F195"
    />
    <path
      d="M18.5 38.4h30.8c.9 0 1.3 1.1.7 1.7l-5.8 5.8c-.4.4-.9.6-1.4.6H12c-.9 0-1.3-1.1-.7-1.7l5.8-5.8c.4-.4.9-.6 1.4-.6z"
      fill="#9945FF"
    />
    <path
      d="M45.5 28H14.7c-.9 0-1.3 1.1-.7 1.7l5.8 5.8c.4.4.9.6 1.4.6H52c.9 0 1.3-1.1.7-1.7l-5.8-5.8c-.4-.4-.9-.6-1.4-.6z"
      fill="#00C2FF"
    />
  </svg>
);
